import { useZero } from "@rocicorp/zero/react";
import { sharedMutators } from "../../shared/mutators";
import { currentSourcePage } from "../lib/sourcePage";

export type CopiedLinkObject = "workflow" | "route" | "space" | "space_git";

export function useRecordLinkCopied() {
  const z = useZero();
  return (object: CopiedLinkObject) =>
    z.mutate(
      sharedMutators.recordLinkCopied({ object, page: currentSourcePage() })
    );
}
